import { css, Global, useTheme } from "@emotion/react";
import React from "react";
import { Theme } from "src/styles/createTheme";

const TailwindCssVars = () => {
    const theme: Theme = useTheme();

    return (
        <Global
            styles={css`
                html {
                    --color-primary: ${theme.palette.primary.main};
                    --color-primary-light: ${theme.palette.primary.light};
                    --color-primary-dark: ${theme.palette.primary.dark};
                    --color-primary-contrast: ${theme.palette.primary.contrastText};

                    --color-secondary: ${theme.palette.secondary.main};
                    --color-secondary-light: ${theme.palette.secondary.light};
                    --color-secondary-dark: ${theme.palette.secondary.dark};
                    --color-secondary-contrast: ${theme.palette.secondary.contrastText};

                    --color-cta: ${theme.palette.cta.background};
                    --color-cta-dark: ${theme.palette.cta.dark};
                    --color-cta-text: ${theme.palette.cta.text};
                }
            `}
        />
    );
};

export default TailwindCssVars;
